import gsap from 'gsap';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import './Contacts.scss';

function Contacts() {

  const { t } = useTranslation();
  
  const tl :any = useRef()
  const timeLine = tl.current = gsap.timeline()
  
  useEffect(() => {
    timeLine.from('.slide-right', {
      x: '-50px',
      opacity: 0,
      duration: .7,
      stagger: {
        each: 0.3,
      },
    });
    timeLine.from('.slide-bottom', {
      y: '50px',
      opacity: 0,
      duration: .7,
      stagger: {
        each: 0.3,
      },
    },'+1');
  },[]);

  const activeLang = localStorage.getItem('i18nextLng');
  return (
    <div  className="contact">
      <div className="contact-container">
        <h2 className="contact-title slide-right">Contact us</h2>
        <div className="contact-main">
          <div className="contact-detail slide-right">
            <div className="top">
              {/* <div className="top-items">
                <p className="title slide-bottom">Work With Us.</p>
                <a href="#" className="link slide-bottom">
                  looc.tzlee@gmail.com
                </a>
              </div> */}
              <div className="top-items">
                <p className="title slide-bottom">Careers.</p>
                <a href="#" className="link slide-bottom">
                  conceptcube.tv@gmail.com
                </a>
              </div>
            </div>
            <div className="bottom slide-bottom">
              <p>
                {activeLang === 'kr' ?
                  <>
                  서울시 성동구 <br />왕십리로 125, 4층 411호 <br/>
                  </>
                  :
                  <>
                    4F-411, 125, Wangsimni-ro,
                    <br />
                    Seongdong-gu,
                    <br />
                    Seoul, Republic of Korea
                    <br />
                  </>
                }
               <br />T 070-4272-8645
              </p>
            </div>
          </div>
          <div className="contact-map ">
            {activeLang === 'kr' ?
              <iframe
                title="looclocation"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.2672191083275!2d127.04388909999999!3d37.54876759999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca49ee880a2b9%3A0x3184b6c03fe0f43!2z64yA7ZWc66-86rWtIOyEnOyauO2KueuzhOyLnCDshLHrj5nqtawg7JmV7Iut66as66GcIDEyNSA07Li1IDQxMQ!5e0!3m2!1sko!2s!4v1706190148368!5m2!1sko!2s"
                frameBorder="0"
                allowFullScreen
                className="slide-right"
              ></iframe>
              :
              
              <iframe
                title="looclocation"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.2672191083275!2d127.04388909999999!3d37.54876759999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca49ee880a2b9%3A0xde8706bb4403a098!2s4f%20411%2C%20125%20Wangsimni-ro%2C%20Seongdong-gu%2C%20Seoul%2C%20South%20Korea!5e0!3m2!1sen!2s!4v1706189637141!5m2!1sen!2s"
                frameBorder="0"
                allowFullScreen
                className="slide-right"
              ></iframe>
            }
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contacts;
